/**
 * Carrega posições do armazém via API no datalist do campo (lista completa do sistema).
 * Ao digitar, refina com filtro `address*cc*` (case-sensitive).
 */
import { loadOptions } from '../../versa/formset.js';
import { fetchWarehouseLocations, resolveCompanyId } from '../utils/location-search.js';

export default function (opts = {})
{
	const companyKey = opts.companyKey || 'target_warehouse_company_id';
	const warehouseKey = opts.warehouseKey || 'target_warehouse_id';
	const debounceMs = opts.debounceMs ?? 280;
	let debounceTimer = null;

	return {

		captureEvents(_this = this)
		{
			this.safeProtoCall(_this);
			const node = document.querySelector(this.selector);
			if (node)
				node.addEventListener('input', (ev) => this._onInput(ev));
		},

		_getScope()
		{
			const coRaw = this.locate(this.makeId(companyKey))?.getValue?.()
				?? document.querySelector(this.makeId(companyKey))?.value;
			const whRaw = this.locate(this.makeId(warehouseKey))?.getValue?.()
				?? document.querySelector(this.makeId(warehouseKey))?.value;
			return { coRaw, whRaw };
		},

		async _reload(searchText = '')
		{
			const node = document.querySelector(this.selector);
			const preserve = String(searchText ?? (node?.value ?? '')).trim();
			const { coRaw, whRaw } = this._getScope();
			const companyId = await resolveCompanyId(coRaw);
			const wh = Number(whRaw);
			if (!companyId || !Number.isInteger(wh) || wh < 1)
			{
				loadOptions(this.selector, [], 'id', ['address'], '-');
				if (node && preserve)
					node.value = preserve;
				return;
			}
			const term = preserve;
			const rows = await fetchWarehouseLocations(companyId, wh, {
				search: term,
				limit: term ? 80 : 0,
				silent: true,
			});
			loadOptions(this.selector, rows, 'id', ['address'], '-');
			// Não chamar refresh(): apagava o texto enquanto o usuário digita (valor interno ainda -1).
			if (node && preserve)
				node.value = preserve;
		},

		_onInput(ev)
		{
			if (ev.inputType === 'insertReplacementText')
				return;
			clearTimeout(debounceTimer);
			const typed = String(ev.target?.value ?? '').trim();
			debounceTimer = setTimeout(() => { void this._reload(typed); }, debounceMs);
		},

		async actions()
		{
			clearTimeout(debounceTimer);
			const node = document.querySelector(this.selector);
			const typed = node ? String(node.value ?? '').trim() : '';
			await this._reload(typed);
		},

	};
}
